var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"messageList",staticClass:"message-list-wrapper",attrs:{"data-test":"message-list"}},_vm._l((_vm.messageList),function(message){return _c('MessageItem',{key:message.id,attrs:{"shouldShowActions":_vm.shouldShowActions,"selectedProjectId":_vm.selectedProjectId,"message":message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }